import { render, staticRenderFns } from "./DatasetList.vue?vue&type=template&id=22b5eb0a&scoped=true&"
import script from "./DatasetList.vue?vue&type=script&lang=js&"
export * from "./DatasetList.vue?vue&type=script&lang=js&"
import style0 from "./DatasetList.vue?vue&type=style&index=0&id=22b5eb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5eb0a",
  null
  
)

export default component.exports